// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"extract":true,"remove":true}!./~/style-loader!./~/css-loader?sourceMap!./~/cssnext-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/sidebar.vue
// module id = 48
// module chunks = 0